export default __webpack_public_path__ + "static/media/cfx-optimize.f5b01639.png";